import { ActividadesInput } from './ArticuloBimLink/ActividadesInput'
import ArticulosInput from './ArticuloBimLink/ArticulosInput'
import FormulaInput from './ArticuloBimLink/FormulaInput'
import { CustomButton } from 'components/ui'
import { useLocation, useNavigate } from 'react-router-dom'
import { useHandleUrl } from 'hooks/useHandleUrl'
import { useArticuloBimLink } from 'context/ArticuloBimLinkContext'
import { Tooltip } from 'react-tooltip'
import Descripcion from './ArticuloBimLink/Descripcion'
import LastUser from './ArticuloBimLink/LastUser'

const NewArticuloBimlink = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { changeLocation } = useHandleUrl()
  const {
    createArticulo,
    selectedActividad,
    selectedArticulo,
    formula,
    // descripcion,
    isEditArticuloMode,
    isFormulaValid,
    hasTouchedFormula,
  } = useArticuloBimLink()

  const handleBack = () => {
    if (isEditArticuloMode) {
      navigate(changeLocation(location.pathname.split('/edit-articulo')[0]))
    } else {
      navigate(changeLocation(location.pathname.split('/new-articulo')[0]))
    }
  }

  const handleCreateArticulo = () => {
    createArticulo()
    handleBack()
  }
  return (
    <div className="new-bimlink-body-container">
      <h1 className="new-bimlink-title">
        {isEditArticuloMode ? 'Editar artículo' : 'Crear artículo'}
      </h1>
      <div className="new-bimlink-form">
        <ActividadesInput />
        <ArticulosInput />
        <FormulaInput
          inputclass={
            !hasTouchedFormula
              ? ''
              : isFormulaValid
                ? 'input-valid'
                : 'input-invalid'
          }
        />
        <Descripcion />
        {isEditArticuloMode && <LastUser />}
      </div>
      <div className="new-bimlink-footer-buttons">
        <CustomButton type="secondary" onClick={handleBack}>
          Cancelar
        </CustomButton>
        <CustomButton
          onClick={handleCreateArticulo}
          disabled={
            !selectedActividad ||
            !selectedArticulo ||
            !formula ||
            !isFormulaValid
          } // Validar descripción
          className="create-articulo-button"
        >
          {isEditArticuloMode ? 'Editar artículo' : 'Crear artículo'}
        </CustomButton>
        <Tooltip
          anchorSelect=".create-articulo-button"
          style={{
            fontSize: '9px',
            display:
              !selectedActividad ||
              !selectedArticulo ||
              !formula ||
              !isFormulaValid
                ? 'block'
                : 'none',
          }}
        >
          {!formula || !selectedActividad || !selectedArticulo
            ? 'No puede haber ningún campo vacío.'
            : !isFormulaValid
              ? 'La fórmula introducida no es válida.'
              : ''}
        </Tooltip>
      </div>
    </div>
  )
}

export default NewArticuloBimlink
